import React from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/navbar/Navbar.js';
import Banner from '../components/Banner.js';
import { useSEO } from '../components/CustomHook';
import pic1 from '../images/notstrom/pic1.jpg';
import v1 from '../images/notstrom/v1.mp4';
import pdfpic1 from '../images/notstrom/pdfpic1.png';
import store from '../images/notstrom/data2.png';
import data from '../images/notstrom/data1.png';
import gateway from '../images/notstrom/gateway1.png';


const Notstrom = () => {
    useSEO(
        "Notstromversorgung - Zuverlässige Stromversorgung im Notfall | Schmid Energieberatung",
        "Entdecken Sie unsere zuverlässigen Notstromlösungen für Ihr Zuhause und Unternehmen. Sicherer Strom auch bei Ausfällen.",
        "Notstrom, Notstromversorgung, Stromausfall, Backup-Strom, Energiesicherheit",
    );

    return (
        <>
            <Navbar />
            <Banner
                videoSrc="/videos/notstromBanner.mp4"
                title="Notstromversorgung"
                subtitle="Sicherer Strom auch bei Ausfällen"
            />

            {/* Content Section */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-6 max-w-screen-lg">
                    <div className="text-center">
                        <h2 className="text-2xl font-bold text-secondary-dark mb-8">
                            Sigen Energy Gateway – Ihre Energie. Immer verfügbar.
                        </h2>
                        <p className="text-gray-700 mb-4">
                            Das Sigen Energy Gateway sorgt gemeinsam mit dem SigenStor für intelligentes
                            Energiemanagement und volle Transparenz. Im Ernstfall reagiert es blitzschnell:
                            Stromausfälle werden automatisch erkannt, und Ihre Verbraucher schalten ohne
                            Unterbrechung auf Notstrom um.
                        </p>
                        <p className="text-gray-700 mb-4">
                            So genießen Sie Sicherheit und Gelassenheit – denn Ihr Zuhause bleibt zuverlässig versorgt,
                            selbst wenn das öffentliche Netz ausfällt.
                        </p>
                        <p className="text-gray-700 mb-4">
                            Mit der mySigen App haben Sie jederzeit alles im Blick: Sie steuern den Energiefluss,
                            überwachen den Verbrauch und behalten die volle Kontrolle.
                        </p>
                        <p className="text-gray-700 mb-8">
                            Eine Lösung, die mehr ist als Technik – sie schenkt Ihnen das gute Gefühl, rund um die Uhr
                            unabhängig und geschützt zu sein.
                        </p>
                    </div>
                </div>
            </section>

            {/* Full Width Image with Text Overlay on Desktop, Below on Mobile */}
            <section className="w-full">
                <div className="relative">
                    <img
                        src={pic1}
                        alt="Stromspeicher"
                        className="w-full h-auto"
                    />
                    {/* Text overlay for desktop */}
                    <div className="absolute top-0 left-0 w-1/2 h-full hidden md:flex items-center p-6">
                        <div className="bg-white bg-opacity-90 p-6 rounded-lg shadow-lg w-full max-w-md">
                            <h2 className="text-2xl font-bold text-secondary-dark mb-4">
                                Stromausfälle? Sie bemerken sie nicht.
                            </h2>
                            <p className="text-base text-gray-700 mb-3">
                                Mit dem patentierten Leistungssteuerungsalgorithmus von Sigenergy
                                erleben Sie die leistungsstärkste Umschaltung der Branche: 0 Millisekunden Lastunterbrechung.
                            </p>
                            <p className="text-base text-gray-700 mb-3">
                                Fällt das öffentliche Netz aus, übernimmt Ihr PV+Speichersystem sofort –
                                ohne Dunkelheit, ohne Unterbrechung, ohne Sorgen.
                            </p>
                            <h3 className="text-lg font-semibold text-secondary-dark mb-3">
                                Ihre Vorteile im Überblick:
                            </h3>
                            <p className="text-base text-gray-700 mb-2">
                                0 ms Umschaltung – nahtloser Übergang, kein Flackern, keine Pause
                            </p>
                            <p className="text-base text-gray-700 mb-2">
                                24/7 Ausfallschutz – maximale Sicherheit rund um die Uhr
                            </p>
                            <p className="text-base text-gray-700 mb-2">
                                Hybrid-Stromquellen – flexible Kombination aus Solar, Speicher und Netz
                            </p>
                            <p className="text-base text-gray-700 mb-2">
                                Mehr Notstrom – Anbindung von Dieselgeneratoren für zusätzliche Versorgung, inkl. 2-Draht-Start und smarter Fernsteuerung über die mySigen App
                            </p>
                            <p className="text-base text-gray-700">
                                So sind Sie in jeder Situation bestens abgesichert – ob zu Hause oder im Unternehmen.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Text section for mobile */}
                <div className="container mx-auto px-6 py-6 max-w-screen-lg md:hidden">
                    <div className="bg-white rounded-lg p-6 shadow-lg max-w-md">
                        <h2 className="text-2xl font-bold text-secondary-dark mb-4">
                            Stromausfälle? Sie bemerken sie nicht.
                        </h2>
                        <p className="text-base text-gray-700 mb-3">
                            Mit dem patentierten Leistungssteuerungsalgorithmus von Sigenergy
                            erleben Sie die leistungsstärkste Umschaltung der Branche: 0 Millisekunden Lastunterbrechung.
                        </p>
                        <p className="text-base text-gray-700 mb-3">
                            Fällt das öffentliche Netz aus, übernimmt Ihr PV+Speichersystem sofort –
                            ohne Dunkelheit, ohne Unterbrechung, ohne Sorgen.
                        </p>
                        <h3 className="text-lg font-semibold text-secondary-dark mb-3">
                            Ihre Vorteile im Überblick:
                        </h3>
                        <p className="text-base text-gray-700 mb-2">
                            0 ms Umschaltung – nahtloser Übergang, kein Flackern, keine Pause
                        </p>
                        <p className="text-base text-gray-700 mb-2">
                            24/7 Ausfallschutz – maximale Sicherheit rund um die Uhr
                        </p>
                        <p className="text-base text-gray-700 mb-2">
                            Hybrid-Stromquellen – flexible Kombination aus Solar, Speicher und Netz
                        </p>
                        <p className="text-base text-gray-700 mb-2">
                            Mehr Notstrom – Anbindung von Dieselgeneratoren für zusätzliche Versorgung, inkl. 2-Draht-Start und smarter Fernsteuerung über die mySigen App
                        </p>
                        <p className="text-base text-gray-700">
                            So sind Sie in jeder Situation bestens abgesichert – ob zu Hause oder im Unternehmen.
                        </p>
                    </div>
                </div>
            </section>

            {/* Text overlay on video */}
                        <div className="inset-0 flex items-center justify-center mt-4">
                            <div className="bg-black bg-opacity-50 p-8 rounded-lg text-center max-w-2xl">
                                <h2 className="text-3xl font-bold text-white mb-4">
                                    0 ms Lastseitige Unterbrechung
                                </h2>
                                <p className="text-xl text-white">
                                    Die patentierte 0-ms-Lastseitenunterbrechung von Sigenergy, Ihr ultimativer Schutz für
                                    unterbrechungsfreie Stromversorgung zu Hause.
                                </p>
                            </div>
                        </div>

            {/* Video section */}
            <div className="container mx-auto px-4 py-8">
                <video
                className="w-full h-auto rounded-xl overflow-hidden"
                autoPlay
                loop
                muted
                playsInline
                >
                <source src={v1} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Product Grid Section */}
            <section className="py-20 bg-gray-800">
                <div className="container mx-auto px-6 max-w-screen-xl">
                    <h2 className="text-3xl font-bold text-primary text-center mb-16">
                        Es gibt immer eine, die Ihren Bedürfnissen entspricht
                    </h2>
                    <div className="products-grid grid grid-cols-1 md:grid-cols-3 gap-10">
                        {/* Single Phase Home Product */}
                        <div className="product-card bg-gray-700 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <img src={gateway} alt="Sigen Gateway Home" className="w-full h-56 object-contain mb-6" />
                            <h3 className="text-2xl font-bold text-white mb-6 text-center">Sigen Gateway HomePro</h3>
                            <div className="specs space-y-4">
                                <div className="phase text-center py-3 px-6 bg-primary text-white rounded-lg font-semibold text-lg">Dreiphasig</div>
                                <div className="storage-container flex items-center justify-center">
                                    <img src={store} alt="Storage Icon" className="w-10 h-10 mr-2" />
                                    <div className="storage">
                                        <div className="count text-center">
                                            <p className="count-label font-bold text-white text-xl">X 1</p>
                                            <p className="text-gray-300 text-base">SigenStor</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="output text-center">
                                    <div className="value-unit flex items-baseline justify-center">
                                        <strong className="text-3xl text-white">30</strong>
                                        <span className="ml-2 text-white text-xl">kW</span>
                                    </div>
                                    <div className="label text-base text-gray-300">Nennleistung (AC)</div>
                                </div>
                                <div className="capacity text-center">
                                    <div className="value-unit flex items-baseline justify-center">
                                        <strong className="text-3xl text-white">48</strong>
                                        <span className="ml-2 text-white text-xl">kWh</span>
                                    </div>
                                    <div className="label text-base text-gray-300">Maximale ESS-Kapazität</div>
                                </div>
                                <div className="generator-container flex items-center justify-center">
                                    <img src={data} alt="Generator Icon" className="w-10 h-10 mr-2" />
                                    <div className="generator">
                                        <div className="value-unit flex items-baseline justify-center">
                                            <strong className="text-3xl text-white">-</strong>
                                            <span className="ml-2 text-white text-xl">kW</span>
                                        </div>
                                        <div className="label text-base text-gray-300">Generator</div>
                                    </div>
                                </div>
                                <div className="dimensions text-center text-base text-gray-300 py-3">
                                    450 / 695 / 163<br />W/H/D (mm)
                                </div>
                            </div>
                        </div>

                        {/* Single Phase Home Product */}
                        <div className="product-card bg-gray-700 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <img src={gateway} alt="Sigen Gateway Home" className="w-full h-56 object-contain mb-6" />
                            <h3 className="text-2xl font-bold text-white mb-6 text-center">Sigen Gateway HomePro-L</h3>
                            <div className="specs space-y-4">
                                <div className="phase text-center py-3 px-6 bg-primary text-white rounded-lg font-semibold text-lg">Dreiphasig</div>
                                <div className="storage-container flex items-center justify-center">
                                    <img src={store} alt="Storage Icon" className="w-10 h-10 mr-2" />
                                    <div className="storage">
                                        <div className="count text-center">
                                            <p className="count-label font-bold text-white text-xl">X 1</p>
                                            <p className="text-gray-300 text-base">SigenStor</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="output text-center">
                                    <div className="value-unit flex items-baseline justify-center">
                                        <strong className="text-3xl text-white">30</strong>
                                        <span className="ml-2 text-white text-xl">kW</span>
                                    </div>
                                    <div className="label text-base text-gray-300">Nennleistung (AC)</div>
                                </div>
                                <div className="capacity text-center">
                                    <div className="value-unit flex items-baseline justify-center">
                                        <strong className="text-3xl text-white">48</strong>
                                        <span className="ml-2 text-white text-xl">kWh</span>
                                    </div>
                                    <div className="label text-base text-gray-300">Maximale ESS-Kapazität</div>
                                </div>
                                <div className="generator-container flex items-center justify-center">
                                    <img src={data} alt="Generator Icon" className="w-10 h-10 mr-2" />
                                    <div className="generator">
                                        <div className="value-unit flex items-baseline justify-center">
                                            <strong className="text-3xl text-white">-</strong>
                                            <span className="ml-2 text-white text-xl">kW</span>
                                        </div>
                                        <div className="label text-base text-gray-300">Generator</div>
                                    </div>
                                </div>
                                <div className="dimensions text-center text-base text-gray-300 py-3">
                                    450 / 695 / 163<br />W/H/D (mm)
                                </div>
                            </div>
                        </div>

                        {/* Single Phase Home Product */}
                        <div className="product-card bg-gray-700 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <img src={gateway} alt="Sigen Gateway Home" className="w-full h-56 object-contain mb-6" />
                            <h3 className="text-2xl font-bold text-white mb-6 text-center">Sigen Gateway HomeMax</h3>
                            <div className="specs space-y-4">
                                <div className="phase text-center py-3 px-6 bg-primary text-white rounded-lg font-semibold text-lg">Dreiphasig</div>
                                <div className="storage-container flex items-center justify-center">
                                    <img src={store} alt="Storage Icon" className="w-10 h-10 mr-2" />
                                    <div className="storage">
                                        <div className="count text-center">
                                            <p className="count-label font-bold text-white text-xl">X 2</p>
                                            <p className="text-gray-300 text-base">SigenStor</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="output text-center">
                                    <div className="value-unit flex items-baseline justify-center">
                                        <strong className="text-3xl text-white">50</strong>
                                        <span className="ml-2 text-white text-xl">kW</span>
                                    </div>
                                    <div className="label text-base text-gray-300">Nennleistung (AC)</div>
                                </div>
                                <div className="capacity text-center">
                                    <div className="value-unit flex items-baseline justify-center">
                                        <strong className="text-3xl text-white">96</strong>
                                        <span className="ml-2 text-white text-xl">kWh</span>
                                    </div>
                                    <div className="label text-base text-gray-300">Maximale ESS-Kapazität</div>
                                </div>
                                <div className="generator-container flex items-center justify-center">
                                    <img src={data} alt="Generator Icon" className="w-10 h-10 mr-2" />
                                    <div className="generator">
                                        <div className="value-unit flex items-baseline justify-center">
                                            <strong className="text-3xl text-white">50</strong>
                                            <span className="ml-2 text-white text-xl">kW</span>
                                        </div>
                                        <div className="label text-base text-gray-300">Generator</div>
                                    </div>
                                </div>
                                <div className="dimensions text-center text-base text-gray-300 py-3">
                                    510 / 795 / 173<br />W/H/D (mm)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="bg-gray-800 py-12">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-2xl font-bold text-white mb-8">Produktinformationen & Downloads</h2>
                    <div className="flex flex-col md:flex-row justify-center gap-6">
                        {/* First PDF Download */}
                        <div className="flex flex-col items-center">
                            <img
                                src={pdfpic1}
                                alt="Gateway Datenblatt"
                                className="mb-4 w-full max-w-xs h-auto"
                                onLoad={() => console.log('pdfPic1 loaded successfully')}
                                onError={(e) => {
                                    console.log('Error loading pdfPic1:', e);
                                    e.target.src = '/images/notstrom/pdfpic1.png'
                                }}
                            />
                            <a
                                href="/pdf/notstrom/Datenblatt.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-primary text-white rounded-lg font-semibold text-base px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                            >
                                Produktinformation Sigen Energy Gateway
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Notstrom;